import React from 'react';
import Box from '../Box/Box';
import { ActionImageIconButton } from '../IconButton';

type TActionIcon = {
  className?: string;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  icon: string;
  color?: string;
  tabIndex?: string;
};

const ActionIcon = ({ icon, onClick, color }: TActionIcon) => {
  return (
    <Box as="div" name="Action-icon" className="action-icon">
      <ActionImageIconButton name={icon} onClick={onClick} color={color} tabIndex="0" />
    </Box>
  );
};

export default ActionIcon;
